/* ============================================================
   proart-search.js
   Pro Art Cartridge — Overlay recherche (Predictive Search API)
   ============================================================ */

(function () {
  'use strict';

  var MIN_CHARS = 2;
  var DEBOUNCE_MS = 300;
  var LIMIT = 6;

  function init() {
    var overlay = document.querySelector('[data-psearch]');
    /* Plusieurs déclencheurs possibles : icône du header + lien du menu mobile. */
    var toggles = document.querySelectorAll('[data-search-toggle]');
    if (!overlay || !toggles.length) return;

    /* Mémorise le déclencheur utilisé pour lui rendre le focus à la fermeture. */
    var lastToggle = toggles[0];

    var baseUrl = overlay.dataset.psearchUrl;
    var input = overlay.querySelector('[data-psearch-input]');
    var results = overlay.querySelector('[data-psearch-results]');
    var allLink = overlay.querySelector('[data-psearch-all]');
    var closeBtn = overlay.querySelector('[data-psearch-close]');

    /* ── Ouverture / fermeture ── */

    function open() {
      overlay.classList.add('open');
      overlay.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      setTimeout(function () { input.focus(); }, 50);
    }

    function close() {
      overlay.classList.remove('open');
      overlay.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      lastToggle.focus();
    }

    Array.prototype.forEach.call(toggles, function (toggle) {
      toggle.addEventListener('click', function (e) {
        e.preventDefault();
        lastToggle = toggle;
        open();
      });
    });

    if (closeBtn) closeBtn.addEventListener('click', close);

    overlay.addEventListener('click', function (e) {
      if (e.target === overlay) close();
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && overlay.classList.contains('open')) close();
    });

    /* ── Rendu des résultats (DOM sûr, pas d'innerHTML avec données API) ── */

    function clearResults() {
      while (results.firstChild) results.removeChild(results.firstChild);
      if (allLink) allLink.hidden = true;
    }

    function showStatus(text, linkHref, linkText) {
      clearResults();
      var p = document.createElement('p');
      p.className = 'psearch__status';
      p.textContent = text;
      if (linkHref) {
        var a = document.createElement('a');
        a.href = linkHref;
        a.textContent = ' ' + linkText;
        p.appendChild(a);
      }
      results.appendChild(p);
    }

    function thumbUrl(url) {
      if (!url) return null;
      return url + (url.indexOf('?') === -1 ? '?' : '&') + 'width=120';
    }

    function renderProducts(products, query) {
      clearResults();

      if (!products.length) {
        showStatus('Aucun produit pour « ' + query + ' »');
        return;
      }

      products.forEach(function (p) {
        var item = document.createElement('a');
        item.className = 'psearch__item';
        item.href = p.url;
        item.setAttribute('role', 'option');

        var imgSrc = thumbUrl(p.featured_image && p.featured_image.url ? p.featured_image.url : p.image);
        if (imgSrc) {
          var img = document.createElement('img');
          img.className = 'psearch__item-img';
          img.src = imgSrc;
          img.alt = '';
          img.width = 60;
          img.height = 60;
          img.loading = 'lazy';
          item.appendChild(img);
        } else {
          var ph = document.createElement('span');
          ph.className = 'psearch__item-img psearch__item-img--empty';
          item.appendChild(ph);
        }

        var info = document.createElement('span');
        info.className = 'psearch__item-info';

        var title = document.createElement('span');
        title.className = 'psearch__item-title';
        title.textContent = p.title;
        info.appendChild(title);

        var meta = document.createElement('span');
        meta.className = 'psearch__item-meta';
        meta.textContent = p.type ? p.type + ' — ' + p.price : p.price;
        info.appendChild(meta);

        item.appendChild(info);
        results.appendChild(item);
      });

      if (allLink) {
        allLink.href = '/search?q=' + encodeURIComponent(query) + '&type=product';
        allLink.hidden = false;
      }
    }

    /* ── Fetch avec debounce + anti-course ── */

    var debounceTimer = null;
    var requestSeq = 0;
    var controller = null;

    function search(query) {
      requestSeq += 1;
      var seq = requestSeq;

      if (controller) controller.abort();
      controller = ('AbortController' in window) ? new AbortController() : null;

      var url = baseUrl +
        '?q=' + encodeURIComponent(query) +
        '&resources[type]=product&resources[limit]=' + LIMIT;

      fetch(url, {
        headers: { Accept: 'application/json' },
        signal: controller ? controller.signal : undefined
      })
        .then(function (r) {
          if (!r.ok) throw new Error('HTTP ' + r.status);
          return r.json();
        })
        .then(function (data) {
          if (seq !== requestSeq) return;
          var products =
            (data.resources && data.resources.results && data.resources.results.products) || [];
          renderProducts(products, query);
        })
        .catch(function (err) {
          if (err.name === 'AbortError' || seq !== requestSeq) return;
          showStatus(
            'Une erreur est survenue —',
            '/search?q=' + encodeURIComponent(query) + '&type=product',
            'voir tous les résultats'
          );
        });
    }

    input.addEventListener('input', function () {
      var q = input.value.trim();
      clearTimeout(debounceTimer);

      if (q.length < MIN_CHARS) {
        requestSeq += 1;
        if (controller) controller.abort();
        clearResults();
        return;
      }

      debounceTimer = setTimeout(function () { search(q); }, DEBOUNCE_MS);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
